"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
// eslint-disable-next-line @typescript-eslint/default-param-last
function preferredLocaleReducer(state, action) {
    if (state === void 0) { state = null; }
    if (action.type === 'PREFERRED_LOCALE_SET') {
        (0, utils_1.setStorageLocale)(action.preferredLocale);
        return action.preferredLocale;
    }
    return state;
}
exports.default = preferredLocaleReducer;
